import React from 'react';
// import ReactDOM from 'react-dom';
import GongqiFormItem from './GongqiFormItem';
import CommandResolver from '../utils/CommandResolver';
import CommandTask from '../forms/sys/remote/CommandTask';
import TreeRefreshArg from '../forms/sys/remote/TreeRefreshArg';
import Cmd from '../forms/sys/remote/Cmd';
import {CommandMapEditorsStore} from '../stores/CommandStore';
import {RefreshPluginStore} from '../stores/CmdTypeStore';
import GOTUtil from '../utils/GOTUtil';

require('../styles/FormItemPluginStyle.css')
export default class FormItemPluginComment extends GongqiFormItem
{

	constructor(props)
	{
        super(props);
        this.state = {
          task: false
        };
		this.unsubscribeCommandMapEditorsStore = CommandMapEditorsStore.listen(this.onMapEditorsHandler.bind(this));
        this.unsubscribeRefreshPluginStore = RefreshPluginStore.listen(this.onRefresh.bind(this));
	}

	componentWillUnmount()
	{
		this.unsubscribeCommandMapEditorsStore();
		this.unsubscribeRefreshPluginStore();
	}

	componentDidMount()
	{
		let key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
		if (window.hasOwnProperty(key)) {
		  let pluginLaterArg = window[key];
		  let tasks = pluginLaterArg.tasks;
		  for(let i = 0;i<tasks.length;i++)
		  {
			  this.refresh(tasks[i]);
		  }
		  window[key] = null;
		  delete window[key];
		}
	}
	
	componentDidUpdate()
	{

	}

	onRefresh(task,pluginName,formId,result)
	{
		if(this.props.xml.name == pluginName && this.props.formId == formId)
		{
			result.push(this.props.xml.name);
			this.refresh(task);
		}
    }
    
    onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if(this.props.moduleInstanceId != moduleInstanceId)
			return;
		if(selector!="all" && this.props.xml.name != selector)
			return;

		var textareavalue = $(this.TextareaValue).val();
		var task = this.state.task;
		if(task){
			var id = task.arg.editorId;
		}else{
			var id = "";
		}
		
		mapEditorValues[this.props.xml.name] = {
		  remoteClass: "java.util.Map",
		  id: id,
		  commentText: textareavalue
		};
		return;
	}

	refresh(task)
	{
		console.log(task);
		this.setState({
		  task: task
		});
	}

	getInputDom(task){
		if(task){
			var comments = task.arg.comments;
			var domLabelItems =[];
			var editorId = task.arg.editorId;
			comments.map((item)=>{
				if(item.id == editorId && task.arg.allowEditor)
				{
					var labelitem = <div>
						<textarea  className="form-control" rows="12" ref={node => this.TextareaValue = node} style={{height:'60px'}}>{item.commentText}</textarea>
					</div> ;
					domLabelItems.push(labelitem);
				}
				else
				{
					var labelitem = <div style={{padding:'10px 5px',display:'flex'}}>
							<div> 
								<img src={item.portraitImage} height="36px;"/>
							</div>
							<div style={{padding:'0 5px',width:'100%'}}>
								<div>
									<span>{item.approvalBy}</span><a>[{item.approvalNode}]</a><span>{item.approvalTime}</span>
								</div>
								<div>{item.commentText}</div>
								<div style={{float:'right'}}>
									<span>操作：{item.approval}</span>
								</div>
							</div>
						</div>;	
					domLabelItems.push(labelitem);
				}
				
			});
			//console.log(domLabelItems);
			let commentLabel = this.props.control.getProperty_Label();
			if(!commentLabel)
			{
				commentLabel = GOTUtil.getPropertyValue(this.props.xml,"Label");
			}
			var inputdom = <div id={this.props.xml.name} className="row gongqiPluginComment" style={{width:'100%'}}>
				 <div className="col-md-3" style={{textAlign:'center'}}>
					{commentLabel}
				</div>
				<div className="col-md-9">
					<div style={{border:'1px solid #d2cfcf'}}>
						{
							domLabelItems.map((item)=>{
								return item;
							})
						}
					</div>
					
				</div>
			</div>;
			

			return inputdom;
		}else{
			return <div id={this.props.xml.name}></div>;
		}
	}

	render()
	{
		const {task} = this.state;
		var inputdom = this.getInputDom(task);
        return (
			<div style={{width:'100%'}}>
			{inputdom}
			</div>
        );
	}

}


// WEBPACK FOOTER //
// ./src/formItem/FormItemPluginComment.js